import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { SectionHeader, Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  link: {
    color: theme.color.link.linkActive01,
  },

  spacing: {
    marginBottom: theme.spacing(6),
  },
  orderList: {
    marginBottom: 0,
  },
}));

const GceInstruction = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <SectionHeader title="Important" />
      <Typography variant="h3">
        {t('amendment->>GroupSubjectAmendmentRegister.BeforeYouBegin')}
      </Typography>
      <ol className={classes.orderList}>
        <li>
          <Typography variant="body1">
            {t('amendment->>GroupSubjectAmendmentRegister.YouNeedFollowingInformation')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('amendment->>GroupSubjectAmendmentRegister.CandidatePersonalParticulars')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('amendment->>GroupSubjectAmendmentRegister.SubjectsPapersRegistered')}
              </Typography>
            </li>
          </ol>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.ALLFieldsAreMandatory')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.ThisFormTake5Minutes')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.AnAmendmentFee')}
            </Typography>
          </li>
        </li>
      </ol>
    </>
  );
};
export default GceInstruction;
